var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "#404040",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_600_2315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.303 0C6.41636 0 0 6.41636 0 14.303C0 22.1897 6.41636 28.6061 14.303 28.6061C22.1897 28.6061 28.6061 22.1897 28.6061 14.303C28.6061 6.41636 22.1898 0 14.303 0ZM14.303 26.7768C7.42499 26.7768 1.82924 21.1812 1.82924 14.303C1.82924 7.42488 7.42499 1.82924 14.303 1.82924C21.1811 1.82924 26.7768 7.42499 26.7768 14.303C26.7768 21.1811 21.1811 26.7768 14.303 26.7768Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6032 18.4721L14.8935 19.473V12.1773C14.8935 11.8579 14.7268 11.5616 14.4539 11.3958C14.181 11.2299 13.8414 11.2183 13.5578 11.3654L11.1208 12.6292C10.6723 12.8617 10.4973 13.4137 10.7298 13.8621C10.9624 14.3106 11.5143 14.4857 11.9628 14.2531L13.0642 13.6819V21.0684C13.0642 21.3961 13.2396 21.6988 13.5239 21.8619C13.6648 21.9427 13.8218 21.983 13.9788 21.983C14.1386 21.983 14.2982 21.9413 14.4408 21.8578L17.5273 20.0511C17.9632 19.7959 18.1098 19.2357 17.8546 18.7997C17.5994 18.3638 17.0391 18.217 16.6032 18.4721Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9785 10.0655C14.6765 10.0655 15.2422 9.49971 15.2422 8.80179C15.2422 8.10386 14.6765 7.53809 13.9785 7.53809C13.2806 7.53809 12.7148 8.10386 12.7148 8.80179C12.7148 9.49971 13.2806 10.0655 13.9785 10.0655Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_600_2315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.6061,
    height: 28.6061,
    fill: "current"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.7c0ccba8.svg";
export { ForwardRef as ReactComponent };